import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack, Typography } from 'components/base';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import ErrorImage from 'assets/img/error.svg';
import { usePublicForm } from 'hooks/module/Form';
import { useVerifyFormLink } from '../../api/queries';
import { useQRStore } from '../../store/useQRStore';

export const VerifyFormLink: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { getRequiredDataFromURL } = usePublicForm();
  const { goToVerifyIdentity } = useQRScreenNavigation();
  const { setDataFromURL } = useQRStore();

  const { fromQR, linkID, hasPrefill, formID, tenantID } =
    getRequiredDataFromURL();

  const {
    data: verifyFormLinkData,
    isPending: isVerificationLoading,
    error: verifyFormLinkError,
    isError: isVerificationError,
  } = useVerifyFormLink(linkID as string);

  useEffect(() => {
    if (isVerificationError) {
      setErrorMessage(
        (verifyFormLinkError?.response?.data as unknown as { message: string })
          ?.message,
      );
      return;
    }
    if (verifyFormLinkData?.data) {
      setDataFromURL({ fromQR, linkID, hasPrefill, formID, tenantID });
      goToVerifyIdentity();
    }
  }, [verifyFormLinkData, isVerificationError]);

  return (
    <>
      {isVerificationLoading ? (
        <Stack alignItems="center" p={2} spacing={1}>
          <Typography>Verifying Form Link. Please wait...</Typography>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {errorMessage && (
            <Stack alignItems="center" maxWidth="400px" p={2}>
              <img src={ErrorImage} alt="error" width="100%" height="100%" />
              <Typography variant="h6" color="text.primary" mt={2}>
                Link not working
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                {errorMessage}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                You can close this window.
              </Typography>
            </Stack>
          )}
        </>
      )}
    </>
  );
};
